import { SupportTicketStatusEnum } from '@api/enum';
import store from '@store/index';
import { getProxyUrl } from 'httpConfig/api-url';
import { v4 as uuidv4 } from 'uuid';

export const getResellerIdFromRedux = () => {
    const {
        auth: { resellerId },
    } = store.getState();

    return resellerId;
    // return resellerId ? resellerId : "61caf1dccb3a8396b119a117";
};

export const getSupportTicketStatusLabel = (role: SupportTicketStatusEnum) => {
    const map = {
        OPEN: 'Open',
        CLOSED: 'Closed',
    };

    return map[role];
};
export const generateProxyUrl = (url: string) => {
    if (!url) return;

    return `${getProxyUrl()}?url=${encodeURIComponent(url)}`;
};
export const generateUniqueId = () => {
    return uuidv4();
};
